'use strict';

angular.module('dekky.forms.validators.collectionMinlength', [])
.directive('collectionMinlength', function() {
	return {
		restrict: 'A',
		require: '?ngModel',
		link: function(scope, element, attr, ngModelController) {
			if (!ngModelController) {
				return;
			}

			scope.$watch(
				function() {
					return ngModelController.$modelValue;
				},
				function () {
					ngModelController.$validate();
				},
				true
			);

			ngModelController.$formatters.unshift(function(value) {
				ngModelController.$setValidity('collectionMinlength', angular.isArray(value) && value.length >= attr.collectionMinlength);

				return value;
			});

			ngModelController.$parsers.unshift(function(value) {
				ngModelController.$setValidity('collectionMinlength', angular.isArray(value) && value.length >= attr.collectionMinlength);

				return value;
			});

			ngModelController.$validators.collectionMinlength = function(modelValue) {
				return angular.isArray(modelValue) && modelValue.length >= attr.collectionMinlength;
			};
		}
	}
});